import { Typography, TypographyProps } from '@mui/material';

interface SafeTypographyProps extends TypographyProps {
	children: React.ReactNode;
}

export default function SafeTypography({ children, ...props }: SafeTypographyProps) {
	return (
		<Typography
			{...props}
			style={{
				padding: 0,
				margin: 0,
				...props.style
			}}
		>
			{children}
		</Typography>
	);
}